import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PatientStatusBadgeComponent } from './patient-status-badge.component';

@NgModule({
  declarations: [PatientStatusBadgeComponent],
  imports: [CommonModule],
  exports: [PatientStatusBadgeComponent],
})
export class PatientStatusBadgeModule {}
